/**
 * Stone Investment Property Overview
 *
 * Stone-themed wrapper for the core PropertyOverview component.
 * Applies Cormorant Garamond headings and Montserrat body with
 * greyscale palette and square-corner aesthetic.
 */

'use client';

import { PropertyOverview, type PropertyOverviewProps } from '@/components/properties';

export type StonePropertyOverviewProps = PropertyOverviewProps;

export function StonePropertyOverview(props: PropertyOverviewProps) {
  return (
    <div
      className="
        relative
        font-['Montserrat',-apple-system,BlinkMacSystemFont,'Segoe_UI',sans-serif]
        [&_h2]:font-['Cormorant_Garamond','Georgia',serif]
        [&_h3]:font-['Cormorant_Garamond','Georgia',serif]
        **:rounded-none
      "
    >
      <PropertyOverview {...props} className="" />
    </div>
  );
}
